import * as actions from "../actions";

const initialState = {
  isTwoFaPopulated: false,
  finished: false,
  hasOtherNames: null,
  otherNames: [
    {
      firstName: "",
      middleName: "",
      lastName: ""
    }
  ],
  placeOfBirth: {
    country: "Australia",
    state: "NSW",
    town: ""
  },
  identificationDetails: {
    "cardNumber": "",
    "stateIssued": "NSW"
  },
  contactPart: { emailAddress: "", mobileNo: "", phoneNo: "" },
  addressesResidential: {
    "addressType": "Residential",
    "enterManually": true,
    "manualAddress": {
      "propertyName": "",
      "unitNo": "",
      "streetNoStart": "",
      "streetNoEnd": "",
      "streetName": "",
      "streetType": "",
      "suburb": "",
      "state": "",
      "postCode": ""
    },
    "lookupValue": {
      "id": "",
      "label": "",
      "value": ""
    },
    "details": {
      "Status": "",
      "Address": {
        "Prefix": null,
        "AddressLine1": "",
        "AddressLine2": null,
        "Suburb": "",
        "State": "",
        "Postcode": "",
        "DPID": null,
        "PostalDeliveryType": null,
        "UniqueId": "",
        "PartialAddress": "",
        "UnitNumber": null,
        "UnitType": null,
        "SubBuildingNumber": null,
        "SubBuildingUnit": null,
        "BuildingNumber": "",
        "BuildingLevel": "",
        "LotNumber": "",
        "PostalType": null,
        "PropertyName": null,
        "StreetName": "",
        "StreetType": "",
        "StreetAddress": null,
        "HouseNumber": "",
        "UnitTypeNumber": " ",
        "Country": "",
        "Latitude": "",
        "Longitude": "",
        "BuildingName": null,
        "LGAName": "",
        "LGAID": "",
        "SA1Code": "",
        "SA2Code": "",
        "SA3Code": "",
        "SA4Code": "",
        "ErrorMessage": null,
        "MatchCertainty": "",
        "MatchQualityPercentage": "",
        "MatchQualityDescription": null,
        "MatchQuality": "",
        "AddressType": 0
      }
    }
  },
  addressesPostal: {
    "addressType": "Residential",
    "enterManually": true,
    "manualAddress": {
      "propertyName": "",
      "unitNo": "",
      "streetNoStart": "",
      "streetNoEnd": "",
      "streetName": "",
      "streetType": "",
      "suburb": "",
      "state": "",
      "postCode": ""
    },
    "lookupValue": {
      "id": "",
      "label": "",
      "value": ""
    },
    "details": {
      "Status": "",
      "Address": {
        "Prefix": null,
        "AddressLine1": "",
        "AddressLine2": null,
        "Suburb": "",
        "State": "",
        "Postcode": "",
        "DPID": null,
        "PostalDeliveryType": null,
        "UniqueId": "",
        "PartialAddress": "",
        "UnitNumber": null,
        "UnitType": null,
        "SubBuildingNumber": null,
        "SubBuildingUnit": null,
        "BuildingNumber": "",
        "BuildingLevel": "",
        "LotNumber": "",
        "PostalType": null,
        "PropertyName": null,
        "StreetName": "",
        "StreetType": "",
        "StreetAddress": null,
        "HouseNumber": "",
        "UnitTypeNumber": " ",
        "Country": "",
        "Latitude": "",
        "Longitude": "",
        "BuildingName": null,
        "LGAName": "",
        "LGAID": "",
        "SA1Code": "",
        "SA2Code": "",
        "SA3Code": "",
        "SA4Code": "",
        "ErrorMessage": null,
        "MatchCertainty": "",
        "MatchQualityPercentage": "",
        "MatchQualityDescription": null,
        "MatchQuality": "",
        "AddressType": 0
      }
    }
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.STORE_APPLICANT_DETAILS:
      return {
        ...state,
        ...action.payload
      };
    case actions.GET_APPLICATION_FULFILLED:
      return {
        ...action.payload.applicantDetails
      };
    case actions.CLEAR_FORM:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
